import { loadingLottie } from "assets/lottie";
import { mainColor, mainSub1Color, white } from "assets/styleUtils";
import { HallInfo } from "components/HallInfo";
import { IHallInfo } from "data/company";
import useUser from "hooks/useUser";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import styles from "./style.module.css";

export interface IHallData {
  data: {
    imgUrl: string;
    name: string;
    checked: boolean;
    contructor_no: number;
    hall?: IHallInfo[];
    booked?: boolean;
  }[];
  setValue: ({
    contructor_no,
    contructor_hall_no,
  }: {
    contructor_no: number;
    contructor_hall_no?: number;
  }) => void;
  totalCount?: number;
  nowPage?: number;
  maxPage?: number;
  selectComplete?: {
    name: string;
    contructor_no: number;
    hall: {
      checked: boolean;
    }[];
  }[];
}

export default function ItemList({
  data,
  setValue,
  totalCount,
  selectComplete,
  nowPage,
  maxPage,
}: IHallData) {
  const [list, setList] = useState(data);
  const navigate = useNavigate();
  useEffect(() => {
    setList(data);
  }, [data]);
  const { user } = useUser();

  return (
    <div style={{ marginTop: 16, minHeight: "300px" }}>
      <p className={styles.count}>총 {totalCount || list?.length}개</p>
      <ul className={styles.list}>
        {list?.map(
          ({ contructor_no, name, imgUrl, checked, hall, booked }, i) => (
            <li key={i} className={`${checked ? styles.selected : ""}`}>
              <div
                className={styles.view}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={styles.viewImg}
                    style={{ backgroundImage: `url("${imgUrl}")` }}
                  />
                  <div className={styles.contructorName}>{name}</div>
                </div>

                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      marginRight: "10px",
                      backgroundColor: mainSub1Color,
                      borderRadius: "5px",
                      padding: "2px 5px 0 5px",
                      color: white,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate(`/company/detail?no=${contructor_no}`);
                    }}
                  >
                    상세보기
                  </div>
                  <div className={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={checked}
                      readOnly
                      onClick={() => {
                        if (!user) {
                          return navigate("/SignIn");
                        }
                        //이미 예약되어 있다면 return시키기(못누르게)
                        if (booked) {
                          return toast.error(
                            "이미 예약 신청하신 웨딩홀은 재예약이 불가합니다. \n[내정보-웨딩홀 예약관리]에서 예약 취소 혹은 변경 부탁드립니다."
                          );
                        }
                        //체크해제
                        if (!!checked) {
                          return setValue({ contructor_no });
                        }
                        //다음 웨딩홀 선택시 홀타입유무
                        if ((selectComplete || []).length > 0) {
                          let lastIndex = (selectComplete || []).length - 1;
                          if (
                            (selectComplete || [])[lastIndex]?.hall.length > 0
                          ) {
                            setValue({ contructor_no });
                          } else {
                            toast.error(
                              (selectComplete || [])[lastIndex]?.name +
                                "의 홀타입을 선택해주세요."
                            );
                            return;
                          }
                        } else {
                          setValue({ contructor_no });
                        }
                      }}
                    />
                    <span />
                  </div>
                </div>
              </div>
              <ul className={styles.subList}>
                <HallInfo
                  hall={hall || []}
                  contructor_no={contructor_no}
                  setValue={setValue}
                />
              </ul>
            </li>
          )
        )}
        {!!nowPage && !!maxPage && nowPage < maxPage && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "0px",
              padding: "50px 120px",
            }}
          >
            <Lottie animationData={loadingLottie} loop={true} />
          </div>
        )}
      </ul>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </div>
  );
}
